import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDownCircleFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4851_1008z)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M34 17C34 26.3888 26.3888 34 17 34C7.61116 34 1.2312e-06 26.3888 0 17C-1.2312e-06 7.61116 7.61116 1.2312e-06 17 0C26.3888 -1.2312e-06 34 7.61116 34 17ZM23.707 17.707C24.0976 17.3165 24.0976 16.6835 23.707 16.293C23.3165 15.9024 22.6835 15.9024 22.293 16.293L18 20.5859V11C18 10.4477 17.5523 10 17 10C16.4477 10 16 10.4477 16 11L16 20.5859L11.707 16.293C11.3165 15.9024 10.6835 15.9024 10.293 16.293C9.90244 16.6835 9.90244 17.3165 10.293 17.707L16.293 23.707C16.6835 24.0976 17.3165 24.0976 17.707 23.707L23.707 17.707Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4851_1008z",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 34,
			height: 34,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgArrowDownCircleFilled);
export { ForwardRef as ReactComponent };
